import { CellContext } from '@tanstack/react-table';
import { LearnerProgress } from '.';
import { CompanyResponse } from '../../../api/admin';
import styled from 'styled-components';
import { TopicPill, TopicText } from '../TopicPill';
import { useTheme } from 'styled-components';
import {
  TooltipContent,
  TooltipDetail,
  TooltipDetailHighlight,
  TooltipTitle,
} from './Tooltip';
import { SmallPortalTooltip } from '../../Tooltip';
import { isEmpty } from 'lodash';

const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export default function OnboardingAnswersCell(
  info: CellContext<
    LearnerProgress,
    CompanyResponse['cohorts'][number]['learners'][number]['onboardingAnswers']
  >
) {
  const theme = useTheme();
  const onboardingAnswers = info.getValue();
  const onboardedAt = info.row.original.onboardedAt;
  const skillsTooltipId = `skills-tooltip-${info.row.id}`;
  const goalsTooltipId = `goals-tooltip-${info.row.id}`;

  if (!onboardedAt) {
    return '-';
  }

  return (
    <PillsContainer>
      <TopicPill
        backgroundColor={theme.colors.bgDefault}
        data-tooltip-id={skillsTooltipId}
      >
        <TopicText>Skills</TopicText>
      </TopicPill>
      <SmallPortalTooltip
        anchorSelect={`[data-tooltip-id="${skillsTooltipId}"]`}
      >
        <TooltipContent>
          <TooltipTitle>Self-assessment</TooltipTitle>
          {isEmpty(onboardingAnswers.skillRatings) && (
            <TooltipDetail>Unknown</TooltipDetail>
          )}
          {Object.entries(onboardingAnswers.skillRatings).map(
            ([skill, rating], index) => (
              <TooltipDetail key={skill}>
                {index + 1}.{' '}
                <TooltipDetailHighlight>{skill}</TooltipDetailHighlight> -{' '}
                {rating}/10
              </TooltipDetail>
            )
          )}
        </TooltipContent>
      </SmallPortalTooltip>
      <TopicPill
        backgroundColor={theme.colors.bgDefault}
        data-tooltip-id={goalsTooltipId}
      >
        <TopicText>Goals</TopicText>
      </TopicPill>
      <SmallPortalTooltip
        anchorSelect={`[data-tooltip-id="${goalsTooltipId}"]`}
      >
        <TooltipContent>
          <TooltipTitle>Workflows</TooltipTitle>
          <TooltipDetail>{onboardingAnswers.commonTasks}</TooltipDetail>
          <TooltipTitle style={{ marginTop: '16px' }}>Other</TooltipTitle>
          <TooltipDetail>{onboardingAnswers.additionalComments}</TooltipDetail>
        </TooltipContent>
      </SmallPortalTooltip>
    </PillsContainer>
  );
}
